import React from 'react';
import { css } from '@emotion/core';
import Table from './Table';
import tableDataType from '../proptypes/table-data';
import TableVideoCard from './TableVideoCard';

const TableVideoDiv = ({ children }) => (children);

const tableCellCss = css`
  flex-direction: column;
`;

const ChallengesTable = ({ data }) => (
  <Table
    data={data}
    customCellRender={(cell, colTitle, cellIndex) => {
      if (cell.type !== 'video-card') return undefined;

      const {
        specialOpsVideoUrl,
        sessionId: [sessionId],
        noVideoMessage,
        isVideoBeingProcessed,
      } = cell;

      return (
        <td key={`cell-${cellIndex}`} css={tableCellCss}>
          <TableVideoDiv>
            <TableVideoCard
              playEventId="compareTableSpecialOpsVideoPlay"
              specialOpsVideoUrl={specialOpsVideoUrl}
              sessionId={sessionId}
              title={colTitle}
              noVideoMessage={noVideoMessage}
              isVideoBeingProcessed={isVideoBeingProcessed}
            />
          </TableVideoDiv>
        </td>
      );
    }}
  />
);

ChallengesTable.propTypes = {
  data: tableDataType.isRequired,
};

export default ChallengesTable;
